// DEPRECATED: this whole file need to be removed and use co-located typed query keys

export enum ORIGIN {
  Backend = "backend"
}

export enum UPDATE_TYPE {
  Static = "static",
  WebSocket = "websocket"
}

interface IQueryKey {
  component: string;
}

export interface IBackendQueryKey extends IQueryKey {
  updateType: UPDATE_TYPE;
  baseUrl: string;
  endpoint: string;
  params?: Record<string, unknown>;
}

export const backendQueryKey = (key: IBackendQueryKey) => {
  return { origin: ORIGIN.Backend, ...key };
};

export interface BackendQueryKey {
  origin: ORIGIN.Backend;
  baseUrl: string;
  endpoint: string;
  params?: Record<string, unknown>;
  data?: Record<string, unknown> | string;
}

export type QueryKeyType = BackendQueryKey;

export enum QUERY_KEY_COMPONENTS {
  Websocket = "websocket",
  PinDropdownOptions = "pinDropdownOptions"
}
